import { Box, styled } from '@mui/material';

import { currentTimeInTimezone } from '#shared';

const PREFIX = 'TSMED-LastUpdate';
export const lastUpdateClasses = {
  root: `${PREFIX}-root`,
  error: `${PREFIX}-error`,
} as const;

type RootProps = {
  compact?: boolean;
};

const Root = styled(Box, {
  name: PREFIX,
  slot: 'Root',
  shouldForwardProp: prop => prop !== 'compact',
})<RootProps>(({ theme: { utils, palette }, compact }) => ({
  [`&.${lastUpdateClasses.root}`]: {
    fontSize: utils.clamp(compact ? 16 : 20, compact ? 24 : 52),
    fontWeight: compact ? 500 : 600,
    color: palette.grey[700],
  },
  [`&.${lastUpdateClasses.error}`]: {
    color: palette.error[500],
  },
}));

interface Props {
  lastUpdateTime: Date;
  networkErrorsCount: number;
  backendNetworkError: string;
  compact?: boolean;
}

export const LastUpdate = ({
  lastUpdateTime,
  backendNetworkError,
  networkErrorsCount,
  compact = false,
}: Props) => {
  const hasError = Boolean(backendNetworkError || networkErrorsCount);

  return (
    <Root
      className={`${lastUpdateClasses.root} ${
        hasError ? lastUpdateClasses.error : ''
      }`}
      compact={compact}
    >
      Last Update: {currentTimeInTimezone(lastUpdateTime, 'America/New_York')}{' '}
      ET
    </Root>
  );
};
